/**
 * This reducer is used for validating products while adding to cart
 */
import {
    VALIDATE_PRODUCTS,
    VALIDATE_PRODUCTS_SUCCESS,
    VALIDATE_PRODUCTS_FAILURE,
    CLEAR_VALIDATED_PRODUCTS,
    CLEAR_TEMPLATE_PRODUCTS,
    SET_CART_LODER,
} from '../actions/actionTypes';

const initialState = {
    validatedProducts: [],
    loadingStatusArray: [],
    loading: false,
    ItemLoader: false,
    statusCode: 0,
    statusMessage: '',
    templateProducts: [],
};

const equityValidateProductsReducer = (state = initialState, action) => {
    switch (action.type) {
        case VALIDATE_PRODUCTS:
            return {
                ...state,
                validatedProducts: [],
                loading: true, 
                loadingStatusArray: Array.isArray(action?.payload?.products)
                    ? action.payload.products.map((product) => ({
                          cfn: product?.cfn,
                          salesOrg: product?.salesOrg,
                          loading: true,
                      }))
                    : [],
                ItemLoader: action?.payload?.isFromSearch,
                statusCode: 0,
            };
        case VALIDATE_PRODUCTS_SUCCESS:
            return {
                ...state,
                validatedProducts: [...action?.validatedProducts],
                loadingStatusArray: initialState.loadingStatusArray,
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
                templateProducts: action?.templateProducts,
            };
        case SET_CART_LODER:
            return {
                ...state,

                ItemLoader: action.payload,
            };
        case VALIDATE_PRODUCTS_FAILURE:
            return {
                ...state,
                validatedProducts: [],
                loadingStatusArray: initialState.loadingStatusArray,
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case CLEAR_VALIDATED_PRODUCTS:
            return {
                ...state,
                validatedProducts: [],
                loadingStatusArray: initialState.loadingStatusArray,
                statusCode: initialState.statusCode,
                statusMessage: initialState.statusMessage,
            };
        case CLEAR_TEMPLATE_PRODUCTS:
            return {
                ...state,
                templateProducts: initialState.templateProducts,
            };

        default: {
            return { ...state };
        }
    }
};

export default equityValidateProductsReducer;
